/* eslint-disable */
import { createRouter, createWebHistory } from 'vue-router';
import PageIndex from '../views/Index.vue';

const routes = [
  {
    path: '/',
    name: 'index',
    component: PageIndex,
  },
  {
    path: '/portailVL',
    name: 'portailVL',
    component: () => import('../views/PortailVL.vue'),
  },
  {
    path: '/autolog',
    name: 'autoLog',
    component: () => import('../views/autoLog.vue'),
  },
  {
    path: '/categorieTecdoc',
    name: 'categorieTecdoc',
    component: () => import('../views/categorieTecdoc.vue'),
  },
  {
    path: '/listeArticle',
    name: 'listeArticle',
    component: () => import('../views/listeArticle.vue'),
  },
  {
    path: '/listeArticleShop',
    name: 'listeArticleShop',
    component: () => import('../views/listeArticleShop.vue'),
  },
  {
    path: '/listeRechercheRef',
    name: 'listeRechercheRef',
    component: () => import('../views/listeRechercheRef.vue'),
  },
  {
    path: '/ficheArticle',
    name: 'ficheArticle',
    component: () => import('../views/ficheArticle.vue'),
  },
  {
    path: '/ficheArticleShop',
    name: 'ficheArticleShop',
    component: () => import('../views/ficheArticleShop.vue'),
  },
  {
    path: '/monpanier',
    name: 'monpanier',
    component: () => import('../views/panier.vue'),
  },
  {
    path: '/monCompte',
    name: 'monCompte',
    component: () => import('../views/monCompte.vue'),
  },
  {
    path: '/mesRayons',
    name: 'mesRayons',
    component: () => import('../views/mesRayons.vue'),
  },
  {
    path: '/portailPL',
    name: 'portailPL',
    component: () => import('../views/PortailPL.vue'),
  },
  {
    path: '/PageNonTrouvee',
    name: 'PageNonTrouvee',
    component: () => import('../views/pageNonTrouvee.vue'),
  },
  {
    path: '/monParc',
    name: 'monParcVue',
    component: () => import('../views/monParc.vue'),
  },
   {
    path: '/mesServices',
    name: 'mesServicesVue',
    component: () => import('../views/mesServices.vue'),
  },
  {
    path: '/mesCommandes',
    name: 'mesCommandes',
    component: () => import('../views/mesCommandes.vue'),
  },
  {
    path: '/enCoursDeDev',
    name: 'enCoursDeDev',
    component: () => import('../views/enCoursDeDev.vue'),
  },
  {
    path: '/mesRetours',
    name: 'mesRetours',
    component: () => import('../views/mesRetours.vue'),
  },
  {
    path: '/mesDevis',
    name: 'mesDevis',
    component: () => import('../views/mesDevis.vue'),
  },
  {
    path: '/ficheArticleExpress',
    name: 'ficheArticleExpress',
    component: () => import('../views/ficheArticleExpress.vue'),
  },
  {
    path: '/devis',
    name: 'devis',
    component: () => import('../views/devis.vue'),
  },
  {
    path: '/portailConsommables',
    name: 'portailCONSO',
    component: () => import('../views/PortailConsommables.vue'),
  },
  {
    path: '/portailEpi',
    name: 'portailEPI',
    component: () => import('../views/portailEpi.vue'),
  },
  {
    path: '/portailMateriel',
    name: 'portailMAT',
    component: () => import('../views/portailMateriel.vue'),
  },
  {
    path: '/portailOutillage',
    name: 'portailOUT',
    component: () => import('../views/portailOutillage.vue'),
  },
  {
    path: '/portailCarrosseriePeinture',
    name: 'portailCARRO',
    component: () => import('../views/PortailCarrosserie.vue'),
  },
  {
    path: '/portailPneumatiques',
    name: 'portailPNE',
    component: () => import('../views/PortailPneumatiques.vue'),
  },
  {
    path: '/listeArticlePneumatiques',
    name: 'listeArticlePneumatiques',
    component: () => import('../views/listeArticlePneumatiques.vue'),
  },
  {
    path: '/mentionsLegales',
    name: 'mentionsLegales',
    component: () => import('../views/mentionsLegales.vue'),
  },
  {
    path: '/protectionDonnees',
    name: 'protectionDonnees',
    component: () => import('../views/protectionDonnees.vue'),
  },
  {
    path: '/generalVentes',
    name: 'generalVentes',
    component: () => import('../views/generalVentes.vue'),
  },
  {
    path: '/nosVideos',
    name: 'nosVideos',
    component: () => import('../views/nosVideos.vue'),
  },
  {
    path: '/:pathMatch(.*)*', 
    name: 'not-found',
    component: () => import('../views/pageNonTrouvee.vue'),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
